import { Box, Stack, Typography } from '@mui/material'
import SectionContainer from './SectionContainer'
import { SectionTemplate } from '../types'
import { pathColor } from '../palette'

interface Company {
  name?: string
  rationale?: string
}

interface Group {
  pathTitle?: string
  companies?: Company[]
}

interface Props {
  template: SectionTemplate
  values: { groups?: Group[] }
  title: string
  description: string
  sectionNumber?: number
}

export default function TagGridSection({ template, values, title, description, sectionNumber }: Props) {
  const groups = values?.groups || []

  return (
    <SectionContainer
      id={template.sectionTypeId}
      number={sectionNumber}
      title={title}
      description={description}
    >
      <Stack spacing={5}>
        {groups.map((group, gi) => {
          const accent = pathColor(gi)
          return (
            <Box key={gi}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 1.5 }}>
                <Box sx={{ width: 32, height: 2, background: accent }} />
                <Typography
                  variant="overline"
                  sx={{ letterSpacing: 2, color: accent, fontWeight: 700 }}
                >
                  {group.pathTitle}
                </Typography>
              </Stack>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
                  gap: 2,
                }}
              >
                {(group.companies || []).map((c, ci) => (
                  <Box
                    key={ci}
                    sx={{
                      p: 2,
                      borderTop: `2px solid ${accent}`,
                      borderRight: 1,
                      borderBottom: 1,
                      borderLeft: 1,
                      borderRightColor: 'divider',
                      borderBottomColor: 'divider',
                      borderLeftColor: 'divider',
                      background: 'rgba(255,255,255,0.7)',
                    }}
                  >
                    <Typography sx={{ fontWeight: 600 }}>{c.name}</Typography>
                    {c.rationale && (
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {c.rationale}
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>
            </Box>
          )
        })}
      </Stack>
    </SectionContainer>
  )
}
